import environment from '#/environment/environment';
import {Experiment} from '@amplitude/experiment-js-client';
import React, {createContext, useContext, useEffect, useState} from 'react';

interface FeatureFlagContextType {
  getFeatureFlag: (flagKey: string) => string | null;
}

const FeatureFlagContext = createContext<FeatureFlagContextType>({
  getFeatureFlag: () => null,
});

interface FeatureFlagProviderProps {
  children: React.ReactNode;
}

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({children}) => {
  const [experiment, setExperiment] = useState<any>(null);
  const amplitudeApiKey = environment.amplitudeApiKey;

  useEffect(() => {
    const initExperiment = async () => {
      const exp = await Experiment.initializeWithAmplitudeAnalytics(amplitudeApiKey);
      await exp.fetch();
      setExperiment(exp);
    };

    initExperiment().catch(console.error); //eslint-disable-line no-console
  }, [amplitudeApiKey]);

  const getFeatureFlag = (flagKey: string): string | null => {
    if (!experiment) return null;
    const variant = experiment.variant(flagKey);
    return variant?.value ?? null;
  };

  return <FeatureFlagContext.Provider value={{getFeatureFlag}}>{children}</FeatureFlagContext.Provider>;
};

export const useFeatureFlags = (flagName: string) => {
  const {getFeatureFlag} = useContext(FeatureFlagContext);
  return getFeatureFlag(flagName);
};
